import { Component } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { FilterField, IFilterField } from 'src/app/shared/interfaces';
import { NativeFocus } from 'src/app/shared/utils';

@Component({
  selector: 'app-filter-modal',
  templateUrl: './filter-modal.component.html',
  styleUrls: ['./filter-modal.component.sass']
})
export class FilterModalComponent {

  private resolve: any;
  public fields: IFilterField[];
  public formulario: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    public bsModalRef: BsModalRef
  ) { }

  public setOption(resolve: any, fields: FilterField[]): void {
    this.resolve = resolve;

    this.formulario = this.fb.group(fields.reduce((form, field) => {
      form[field.field] = [field.value !== null ? field.value : null];
      return form;
    }, {}));

    this.fields = fields.map((field): IFilterField => {
      const res: IFilterField = {
        field: field.field,
        title: field.title,
        type: 'input',
        items: field.items,
        autoComplete: null,
        classCol: field.classCol ? field.classCol : 'col-12',
        customConfig: field.customConfig
      };

      if (field.service) {
        res.type = 'auto-complete';
        if (field.autoComplete) {
          res.autoComplete = field.autoComplete;
        } else if (field.service) {
          res.autoComplete = field.service.autoComplete.bind(field.service);
        }
      } else if (field.date) {
        res.type = 'datepicker';
      } else if (field.items && field.items.length > 0) {
        res.type = 'select';
      }

      return res;
    });

    if (fields.length > 0) {
      NativeFocus(this.formulario.controls[fields[0].field]);
    }
  }

  public done(event: Event): void {
    this.resolve(this.formulario.value);
    this.bsModalRef.hide();
  }
}
